/* istanbul ignore file */
export enum UserAccountSettingsTab {
    General = 0,
    Notifications = 1
}
